<template>
  <div class="login-container">
    <!--    <LogoIcon class="logo-icon" />-->
    <span class="title">Add your artist profile</span>
    <div class="login-content">
      <div class="artists">
        <div v-for="artist in artists" :key="artist.spotify_id" class="artist">
          <div class="source-card">
            <div class="source-image">
              <img :src="artist.avatar_url" v-if="artist.avatar_url" />
              <div v-else class="avatar-placeholder">
                <span>{{ artist.name.charAt(0) }}</span>
              </div>
            </div>
            <div class="source-text">
              <span class="source-title">
                {{ artist.name }}
              </span>
              <!--              <span class="source-subtitle">-->
              <!--                {{ artist.subtitle }}-->
              <!--              </span>-->
            </div>
            <div class="source-actions">
              <div
                v-if="artists.length > 1"
                @click="removeArtist(artist)"
                class="remove"
              >
                <RemoveIcon class="icon extra-small" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        @click="next()"
        class="button-default big continue"
        :disabled="noArtists || saving"
      >
        <span>Continue</span>
      </button>
      <!--      <div class="or">-->
      <!--        <span>OR</span>-->
      <!--      </div>-->
      <!--      <div class="inputs">-->
      <!--        <div class="floating-label has-icon">-->
      <!--          <input-->
      <!--            v-model="spotify_link"-->
      <!--            @paste="getMeta"-->
      <!--            placeholder="Enter Spotify Artist Link"-->
      <!--            type="text"-->
      <!--            name="spotify"-->
      <!--            id="spotify"-->
      <!--            autocomplete="off"-->
      <!--          />-->
      <!--          <label for="spotify">-->
      <!--            Enter Spotify Artist Link-->
      <!--          </label>-->
      <!--          <div class="input-icon">-->
      <!--            <SpotifyIcon class="icon small" />-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <button-->
      <!--        @click="getMeta"-->
      <!--        :disabled="!spotify_link || saving"-->
      <!--        class="button-secondary big add"-->
      <!--      >-->
      <!--        <span>Add another artist</span>-->
      <!--      </button>-->
    </div>
  </div>
</template>
<script>
// import LogoIcon from "../../../public/img/icons/logo.svg";
// import SpotifyIcon from "../../../public/img/icons/spotify.svg";
import RemoveIcon from "../../../public/img/icons/remove.svg";
import { mapState } from "vuex";
import { M_ADD_AGENCY_ARTISTS, M_ADD_FAMILY_ARTISTS, Q_META } from "@/graphql";
export default {
  name: "AddArtistWizardStepAddAnotherArtist",
  components: {
    // LogoIcon,
    // SpotifyIcon,
    RemoveIcon
  },
  data() {
    return {
      spotify_link: null,
      sourceLoaded: false,
      sourceLoading: false,
      saving: false
    };
  },
  async created() {},
  computed: {
    ...mapState("addArtist", ["artists"]),
    user() {
      return this.$store.getters.getUser;
    },
    noArtists() {
      return this.artists.length === 0;
    },
    isAgencyPlan() {
      return this.user.plan === "agency" || !!this.user.master_account_id;
    },
    isFamilyPlan() {
      return this.user.plan === "family";
    }
  },
  methods: {
    getMeta() {
      setTimeout(async () => {
        if (this.spotify_link.indexOf("open.spotify.com/artist") === -1) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a Spotify artist link."
          });
          this.spotify_link = null;
          return;
        }
        const spotify_id = this.spotify_link
          .split("?")[0]
          .replace("https://open.spotify.com/artist/", "")
          .replace("http://open.spotify.com/artist/", "");
        console.log(spotify_id);
        const duplicate = this.user.artists.filter(
          artist => artist.spotify_id === spotify_id
        );
        if (duplicate.length) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! You already have this artist added to your account."
          });
          this.spotify_link = null;
          return;
        }
        const metaUrl = this.spotify_link.split("?")[0];
        await this.$store.dispatch("snack", {
          text: "Loading metadata, please wait...",
          autoDismiss: false
        });
        const result = await this.$apollo.query({
          query: Q_META,
          variables: {
            url: metaUrl
          }
        });
        this.$store.commit("resetSnack");
        console.log(result);
        const metaData = JSON.parse(result.data.meta.data);
        console.log(metaData);
        this.$store.commit("addArtist/addArtist", {
          spotify_id: spotify_id,
          name: metaData["og_title"],
          avatar_url: metaData["og_image"]
        });
        this.sourceLoaded = true;
        this.spotify_link = null;
      });
    },
    async removeArtist(artist) {
      this.$store.commit("addArtist/removeArtist", artist.spotify_id);
    },
    async addAgencyArtists() {
      try {
        this.saving = true;
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_ADD_AGENCY_ARTISTS,
          variables: {
            artists: this.artists.map(x => ({
              id: x.spotify_id,
              name: x.name,
              image: x.avatar_url,
              selected_plan: "pro"
            }))
          }
        });

        console.log(response);
        const { user, token } = response.data.braintree_add_agency_artists;
        if (token) {
          localStorage.setItem("token", token);
          await this.$store.dispatch("setUser", user);
          await this.$store.dispatch("setArtist", user.artists[0]);
          this.$store.commit("signup/setArtists", user.artists);
          this.$emit("setStep", 5);
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      } finally {
        this.saving = false;
      }
    },
    async addFamilyArtists() {
      try {
        this.saving = true;
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_ADD_FAMILY_ARTISTS,
          variables: {
            artists: this.artists.map(x => ({
              id: x.spotify_id,
              name: x.name,
              image: x.avatar_url,
              selected_plan: "pro"
            }))
          }
        });

        console.log(response);
        const { user, token } = response.data.braintree_add_family_artists;
        if (token) {
          localStorage.setItem("token", token);
          await this.$store.dispatch("setUser", user);
          await this.$store.dispatch("setArtist", user.artists[0]);
          this.$store.commit("signup/setArtists", user.artists);
          this.$emit("setStep", 5);
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      } finally {
        this.saving = false;
      }
    },
    async next() {
      if (this.isAgencyPlan) {
        await this.addAgencyArtists();
      } else if (this.isFamilyPlan) {
        await this.addFamilyArtists();
      } else {
        this.$emit("nextStep");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  /* BG/type2 */
  //background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;
    .artists {
      width: 620px;
      display: grid;
      grid-gap: 24px;
      .artist {
        display: flex;
        flex-direction: column;
        &:not(:last-child):after {
          margin-top: 24px;
          content: "";
          width: 100%;
          height: 1px;
          border-bottom: 1px solid $purple-dark;
        }
        .source-card {
          //margin-top: 30px;
          display: flex;
          .source-image {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              /* Shadow-button */
              filter: drop-shadow(0px 0px 10px rgba(23, 18, 43, 0.45));
              border-radius: 1000px;
              width: 120px;
              height: 120px;
              object-fit: cover;
            }
            .avatar-placeholder {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 120px;
              height: 120px;
              border-radius: 1000px;
              background: $purple;
              span {
                font-weight: bold;
                font-size: 48px;
                line-height: 64px;
                color: white;
              }
            }
          }
          .source-text {
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            .source-title {
              /* 24/Bold */
              font-weight: bold;
              font-size: 24px;
              line-height: 32px;
              color: white;
            }
            .source-subtitle {
              /* 14/SemiBold */
              font-weight: 600;
              font-size: 14px;
              line-height: 32px;
              color: white;
            }
          }
          .source-actions {
            .remove {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 28px;
              height: 28px;
              border-radius: 50%;
              border: 1px solid $purple;
              &:hover {
                cursor: pointer;
                background: $red;
              }
              svg {
                path {
                  fill: white;
                }
              }
            }
          }
        }
      }
    }
    .or {
      margin-top: 24px;
      display: flex;
      align-items: center;
      span {
        display: grid;
        grid-template-columns: 16px 1fr 16px;
        align-items: center;
        grid-gap: 10px;
        /* 12/Regular */
        font-size: 12px;
        line-height: 18px;
        color: white;
        &:before {
          content: "";
          width: 16px;
          height: 1px;
          background-color: #c4c4c4;
        }
        &:after {
          content: "";
          width: 16px;
          height: 1px;
          background-color: #c4c4c4;
        }
      }
    }
    .inputs {
      margin-top: 24px;
      display: grid;
      grid-template-columns: repeat(1, 460px);
    }
    button.continue {
      margin-top: 30px;
      width: 276px;
    }
    button.add {
      margin-top: 24px;
      padding: 9px 18px;
    }
  }
}
</style>
